import React from 'react';
import { PlusIcon } from '@heroicons/react/solid';

const FloatingActionButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 w-12 h-12 bg-[#4CAF50] hover:bg-[#43A047] text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center z-50 focus:outline-none focus:ring-4 focus:ring-green-200"
      aria-label="Create Event"
    >
      <PlusIcon className="h-6 w-6" />
    </button>
  );
};

export default FloatingActionButton;
